export default __webpack_public_path__ + "static/media/hostImgJ2.fae15053.jpg";